import React, { useState } from "react";
import { useSelector } from "react-redux";
import { i18n } from '../../../translate/i18n';
import AddCircleOutline from '@mui/icons-material/AddCircleOutline';
import ModalAttachmentFilesEquipments from '../Modals/ModalAttachmentFilesEquipments';
import {
  Paper, Typography, Button, Dialog, Divider,
} from '@mui/material';
import { FormStyled, styleModal } from './styles'
import AttachmentsViewer from "../../../UI/AttachmentsViewer/AttachmentsViewer";
import Spinner from "../../../components/Spinner";
import { EAccessRole } from "../../../store/types";

export default function AttachmentsListEquipments(props) {
  const styles = {
    spinner: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      top: '-5px',
      opacity: '1',
      zIndex: 2,
    },
    noResults: {
      textAlign: 'center'
    },
    headerButtonsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState(false);
  const [modalContent, setModalContent] = useState({});

  // get from redux
  const attachments = useSelector((state) => state.equipments.equipment.attachments) || [];
  const loading = useSelector((state) => state.equipments.loading)
  const selectedAccess = useSelector((state) => state.auth.selectedAccess)
  const loadingEquipments = useSelector(state => state.equipments.loading);
  const role = selectedAccess.role

  const isAnalyst = role === EAccessRole.analyst;
  const isContractor = role === EAccessRole.contractor;
  const isInspector = selectedAccess.inspector && (isAnalyst || isContractor);

  const setOpenModal = (open, type, doc = {}) => {
    setIsModalOpen(open);
    setModalType(type);
    setModalContent(doc)
  }

  return (
    <Paper>
      <FormStyled style={{ opacity: loadingEquipments ? '0.3' : '1' }}>
        <Dialog
          scroll='body'
          fullWidth
          open={isModalOpen}
          onClose={() => setOpenModal(false, 'close')}
          PaperProps={{
            style: styleModal,
          }}
        >
          <ModalAttachmentFilesEquipments
            type={modalType}
            closeModal={setOpenModal}
            modalContent={modalContent}
          />
        </Dialog>
        <div style={styles.headerButtonsContainer}>
          <Typography variant='h6' style={{ padding: '20px 20px 20px 0' }}>
            {
              i18n.t('attachmentFilesEquipmentsTypo.label')
            }
          </Typography>
          <Button
            style={{marginRight: 40}}
            variant='outlined'
            aria-label="add"
            disabled={isInspector}
            onClick={() => setOpenModal(true, 'new', {})}
            startIcon={<AddCircleOutline />}
          >
            {i18n.t('supportBtn.label')}
          </Button>
        </div>
        <Divider style={{marginBottom: 10}}/>
        {loading &&
          <div>
            <Spinner overlay />
          </div>
        }
        {attachments && attachments.length === 0 && !loading ?
          <div style={styles.noResults}>
            {!loading && <Typography>{i18n.t('attachmentFilesEquipmentModelsTypo.noResults')}</Typography>}
          </div>
          :
          <AttachmentsViewer role={role} attachments={attachments} setOpenModal={(attachment) => setOpenModal(true, 'edit', attachment)} />
        }
      </FormStyled>
    </Paper>
  );

}
